import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import { Route } from 'react-router-dom';
import { Setting } from '../../../feature/setting/page/setting';
import { AppNavbar } from './app-navbar';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minHeight: '100%',
    },
    child: {
      flexGrow: 1,
      marginBottom: 16,
      maxWidth: 1032,
    },
    toolbar: theme.mixins.toolbar,
  };
});

const Layout = ({ children, ...rest }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container className={classes.child}>
        <AppNavbar />
        <Setting>{children}</Setting>
      </Container>
    </div>
  );
};
export const AppSettingLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};
